import { Button, Stack } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import AdvancedQueryBuilder from "../../AdvancedQuery/AdvancedQueryBuilder/advanced-query-builder";
import { DbSearchAdvancedQueryInfos } from "../../../Core/Api/Types/db-search-advanced-query-infos";
import { useTranslation } from "react-i18next";

export type ModalSearchQueryBuilderElementProps = {
  query?: string;
  layer?: ObjectLayer;
  onValidate?: (newQuery: string) => void;
  hideButtons?: boolean;
};

export type ModalSearchQueryBuilderProps = CommonModalProps<ModalSearchQueryBuilderElementProps>;

const ModalSearchQueryBuilder = forwardRef<any, ModalSearchQueryBuilderProps>((props, ref) => {
  const { t } = useTranslation();
  const { query, closeModal, onValidate, hideButtons, ...modalProps } = props;

  const [currentQuery, setCurrentQuery] = useState(query ?? "");

  const onChangeFocus = () => {};

  const onClickSearch = () => {};

  const onQueryChange = (newQuery: string) => {
    setCurrentQuery(newQuery);
  };

  return (
    <Modal
      title={t("modal:title.searchQueryBuilder")}
      reference={ref}
      closeModal={closeModal}
      width={1024}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={closeModal}>
            {t("common:cancel")}
          </Button>

          <Button
            variant="outlined"
            color="success"
            disabled={false}
            onClick={() => {
              if (onValidate) {
                onValidate(currentQuery);
                closeModal();
              }
            }}
          >
            {t("common:validate")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={2}>
        <AdvancedQueryBuilder
          sx={{ flex: 1 }}
          onChangeFocus={onChangeFocus}
          onClickSearch={onClickSearch}
          onQueryChange={onValidate && onQueryChange}
          addAdvancedQuery={() => {}}
          advancedQueries={[]}
          hideButtons={hideButtons}
          textSearch={query ?? ""}
          textQuery={query ?? ""}
        />
      </Stack>
    </Modal>
  );
});

export default ModalSearchQueryBuilder;
